// extracted by mini-css-extract-plugin
export default {"container":"PasswordForm_container__mUAiA","bottom":"PasswordForm_bottom__ouuox"};